jQuery(document).ready(function ($) {

    // Mobile toggle
    $('.header__toggle').on('click', function (e) {
        e.preventDefault();
        $(".mobile").toggleClass("mobile--open");
        $(this).toggleClass('header__toggle__icon--open');
    });

    // Module slider
    $('.module__slider__content').slick({
        arrows: true,
        nextArrow: $('.module__slider__nav__right'),
        prevArrow: $('.module__slider__nav__left'),
        dots: false
    });

    // Scroll to hash
    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();

        var scrollTop = $( $(this).attr('href') ).position().top;
        $('html, body').animate({ scrollTop: scrollTop });
    });


    // Single course page check and change
    if( $("#home").length ) {
        $('.header__menu--course ul li a, .mobile--course ul li a').on('click', function(e) {
            $('section').hide();

            var href = $(this).attr("href");
            $(href).show();

            if($('.mobile--open')[0]) {
                $(".mobile").toggleClass("mobile--open");
                $(this).toggleClass('header__toggle__icon--open');
            }
        });

        var active_tab = $(location).attr('hash');
        if(active_tab) {
            $('section').hide();
            $(active_tab).show();
        }
    }

});

$(document).on('keypress', function(e){
    if (e.which == 49) {
        jQuery( '.step:visible input:eq(0)' ).prop( "checked", true );
    }
    if (e.which == 50) {
        jQuery( '.step:visible input:eq(1)' ).prop( "checked", true );
    }
    if (e.which == 51) {
        jQuery( '.step:visible input:eq(2)' ).prop( "checked", true );
    }
    if (e.which == 52) {
        jQuery( '.step:visible input:eq(3)' ).prop( "checked", true );
    }
    if (e.which == 53) {
        jQuery( '.step:visible input:eq(4)' ).prop( "checked", true );
    }
    if (e.which == 54) {
        jQuery( '.step:visible input:eq(5)' ).prop( "checked", true );
    }
    if (e.which == 55) {
        jQuery( '.step:visible input:eq(6)' ).prop( "checked", true );
    }
    if (e.which == 56) {
        jQuery( '.step:visible input:eq(7)' ).prop( "checked", true );
    }
    if (e.which == 57) {
        jQuery( '.step:visible input:eq(8)' ).prop( "checked", true );
    }

    if (e.which == 39) {
        elearning.nextStep();
    }
    if (e.which == 37) {
        elearning.previousStep();
    }
});
